// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
// import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext"; // Store Custom Code
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
// import ProductListActions from "@insite/content-library/Widgets/ProductList/ProductListActions"; // Store Custom Code
// import ProductListProductImage from "@insite/content-library/Widgets/ProductList/ProductListProductImage"; // Starter Custom Code
// import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation"; // Store Custom Code
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import React, { FC } from "react"; // Starter Custom Code
import { css } from "styled-components";

/* Starter Custom Code - Start */
import React, { FC, useMemo } from "react";
import ProductListProductImage, {
    ProductListProductImageStyles,
} from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
// import ProductListActions from "@store/Overrides/Widgets/ProductList/ProductListActions"; // Store Custom Code
// import ProductListProductInformation from "@store/Overrides/Widgets/ProductList/ProductListProductInformation"; // Store Custom Code
// import { productCardProps } from "@store/Themes/common/props/productCard"; // Store Custom Code
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";

/* Store Custom Code - Start */
import { HasProduct, ProductContext, withProduct } from "@insite/client-framework/Components/ProductContext";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import { getMultiLocationCatalogResult } from "@store/Framework/Common/Utilities/multiLocationCatalogUtilities";
import AvailableAtOtherShipToLabel, {
    AvailableAtOtherShipToLabelPresentationProps,
} from "@store/Library/Components/MultiLocationCatalog/AvailableAtOtherShipToLabel";
import NotInYourCatalogBadge, {
    NotInYourCatalogBadgePresentationProps,
} from "@store/Library/Components/NotInYourCatalogBadge";
import ProductListMultiLocationCatalogProductInformation from "@store/Library/Components/ProductList/ProductListMultiLocationCatalogProductInformation";
import ProductListActions from "@store/Overrides/Widgets/ProductList/ProductListActions";
import ProductListProductInformation from "@store/Overrides/Widgets/ProductList/ProductListProductInformation";
import { productCardProps } from "@store/Themes/common/props/productCard";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import { HTMLAttributes } from "react";
/* Store Custom Code - End */

interface OwnProps {
    useAlternativeDisplayOnMobile?: boolean;
    // Store Custom Code
    showAddToCart: boolean;
    showBreakPricing: boolean;
    showLeadTime: boolean;
    showWarehouseAndFullTruckLoad: boolean;
}
/* Starter Custom Code - End */

type Props = ProductCardSelections & HasProduct & OwnProps & HTMLAttributes<HTMLDivElement>; // Store Custom Code

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    // Starter Custom Code
    productListProductImage?: ProductListProductImageStyles;
    // Store Custom Code
    availableAtOtherShipToLabel?: AvailableAtOtherShipToLabelPresentationProps;
    notInYourCatalogBadge?: NotInYourCatalogBadgePresentationProps;
    cardLink?: ClickablePresentationProps;
}

/* Store Custom Code - Start */
const badgeWrapperProps = {
    extendedStyles: {
        wrapper: {
            css: css`
                position: absolute;
                top: ${pxToRem(6)};
                left: ${pxToRem(6)};
                z-index: 2;
                pointer-events: none;
            `,
        },
    },
};
/* Store Custom Code - End */

export const productGridCardStyles: ProductListProductGridCardStyles = {
    wrapper: productCardProps.card,
    imageWrapper: productCardProps.image?.wrapper,
    sponsoredText: mergeProps<ProductListProductGridCardStyles["sponsoredText"]>(productCardProps.sponsoredText, {
        css: css`
            border-left: 0;
        `,
    }),
    productListProductImage: {
        compareCheckbox: {
            mergeCss: true,
            css: css`
                margin-bottom: ${pxToRem(-4)};
            `,
        },
    },
    /* Store Custom Code - Start */
    cardLink: {
        css: css`
            ${focusStyles()}
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            ~ * {
                &:is(a, button),
                a,
                button {
                    position: relative;
                    z-index: 1;
                }
            }
        `,
    },
    availableAtOtherShipToLabel: badgeWrapperProps,
    notInYourCatalogBadge: badgeWrapperProps,
    /* Store Custom Code - End */
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
    // Starter Custom Code
    useAlternativeDisplayOnMobile,
    // Store Custom Code
    showAddToCart,
    showBreakPricing,
    showLeadTime,
    onUnitOfMeasureChanged,
    onQtyOrderedChanged,
    showWarehouseAndFullTruckLoad,
    ...htmlAttributes
}) => {
    /* Store Custom Code - Start */
    const productContext = React.useContext(ProductContext);
    const multiLocationCatalogResult = getMultiLocationCatalogResult(product);
    const isMLCProduct = Boolean(multiLocationCatalogResult?.isMultiLocationCatalogProduct);
    const isProductNotInCatalog = getBooleanProperty(product.properties?.notInCatalog);

    const ProductListProductInformationComponent = isMLCProduct
        ? ProductListMultiLocationCatalogProductInformation
        : ProductListProductInformation;
    /* Store Custom Code - End */

    /* Starter Custom Code - Start */
    const wrapperStyles = useMemo(() => {
        if (useAlternativeDisplayOnMobile) {
            return mergeProps<ProductListProductGridCardStyles["wrapper"]>(styles.wrapper, {
                css: css`
                    ${breakpoint("xs", "only")} {
                        padding: ${pxToRem(10)};
                    }
                `,
            });
        }
        return styles.wrapper;
    }, [useAlternativeDisplayOnMobile, styles.wrapper]);
    /* Starter Custom Code - End */

    return (
        <StyledWrapper
            {...wrapperStyles} // Starter Custom Code
            data-test-selector={`productListProductCard${product.id}`}
            // Store Custom Code
            {...htmlAttributes}
        >
            {/* Store Custom Code - Start */}
            {isMLCProduct && (
                <>
                    <Clickable
                        {...styles.cardLink}
                        href={productContext.productInfo.productDetailPath}
                        aria-hidden="true"
                        tabIndex={-1}
                        onClick={(event: React.MouseEvent<HTMLElement>) => event.currentTarget.blur()}
                    >
                        <VisuallyHidden>{product.productTitle}</VisuallyHidden>
                    </Clickable>
                    <AvailableAtOtherShipToLabel {...styles.availableAtOtherShipToLabel} />
                </>
            )}
            {!isMLCProduct && isProductNotInCatalog && <NotInYourCatalogBadge {...styles.notInYourCatalogBadge} />}
            {/* Store Custom Code - End */}
            {showImage /* Starter Custom Code */ ? (
                <StyledWrapper {...styles.imageWrapper}>
                    {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                    <ProductListProductImage
                        showImage={showImage}
                        showCompare={showCompare}
                        showImageBadge={showImageBadges}
                        showTextBadge={showTextBadges}
                        extendedStyles={styles.productListProductImage}
                    />
                </StyledWrapper>
            ) : null}
            <ProductListProductInformationComponent /* Store Custom Code */
                showAttributes={showAttributes}
                showAvailability={showAvailability}
                showBrand={showBrand}
                showPartNumbers={!isProductNotInCatalog ? showPartNumbers : false} // Store Custom Code
                showTitle={showTitle}
                showImageBadges={showImageBadges}
                maxImageBadges={maximumNumberOfImageBadges}
                showTextBadges={showTextBadges}
                maxTextBadges={maximumNumberOfTextBadges}
                // Starter Custom Code
                useAlternativeDisplayOnMobile={useAlternativeDisplayOnMobile}
                // Store Custom Code
                showLeadTime={showLeadTime}
                showWarehouseAndFullTruckLoad={showWarehouseAndFullTruckLoad}
            />
            <ProductListActions
                showAddToList={showAddToList}
                showPrice={showPrice && !isMLCProduct} // Store Custom Code
                // Starter Custom Code
                useAlternativeDisplayOnMobile={useAlternativeDisplayOnMobile}
                // Store Custom Code
                showAddToCart={showAddToCart}
                showBreakPricing={showBreakPricing}
            />
        </StyledWrapper>
    );
};

export default withProduct(ProductListProductGridCard);
